export default {
  props: {
    id: {
      type: String,
      required: false,
      validator(value) {
        return value.length > 1;
      },
    },
  },
};
